import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../models'
import { events } from '../../../../models/analytics/analytics-events'
import { BaseButton } from './BaseButton'

export const PlayAgainButton = observer(() => {
  const {
    analytics: { setEvent },
    game: { clearWalkthrough, setWalkthroughType, walkthroughType },
    session: { user }
  } = useStore()

  if (!walkthroughType) return null

  const handlePlayAgain = () => {
    clearWalkthrough()
    if (walkthroughType === 'RaiseOrFold') {
      setEvent(events.homescreen.raise_or_fold_play_again_tapped, { userId: user?._id.toString() })
    } else if (walkthroughType === 'DealTheFlop') {
      setEvent(events.homescreen.deal_the_flop_play_again_tapped, { userId: user?._id.toString() })
    }
    setWalkthroughType(walkthroughType)
  }

  return <BaseButton text="Play Again" onPress={handlePlayAgain} outlined />
})
